// Explicit icon map so webpack only bundles the icons we actually use
// (a namespace `import * as` would pull in the entire lucide-react set).
import {
  Award,
  Building2,
  Cloud,
  Cpu,
  Database,
  Factory,
  Globe,
  GraduationCap,
  HeartPulse,
  Landmark,
  Lightbulb,
  Rocket,
  ShieldCheck,
  ShoppingBag,
  Smartphone,
  Sparkles,
  Square,
  TrendingUp,
  Truck,
  Users,
} from "lucide-react";

const ICONS = {
  // services
  Sparkles,
  Smartphone,
  Globe,
  Cloud,
  Database,
  Rocket,
  // industries
  HeartPulse,
  Landmark,
  ShoppingBag,
  Factory,
  Truck,
  Cpu,
  GraduationCap,
  Building2,
  // core values
  Lightbulb,
  ShieldCheck,
  Award,
  Users,
  TrendingUp,
};

/**
 * Resolve a lucide-react icon component by its string name.
 * Falls back to a neutral square if the name is unknown.
 */
export const getIcon = (name) => ICONS[name] || Square;
